import { buildClientCard } from '../../shared';

export const buyerCard = buildClientCard({
  id: 'buySideContacts.buyersX',
  entityType: 'counterpartyClient',
  label: 'Buyer',
  showSameAsProperty: false,
});
